import {Component, OnInit} from '@angular/core';
import {DirectorBonusService} from '../../../shared/services/director-bonus.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-director-bonus',
  templateUrl: './director-bonus.component.html',
  styleUrls: ['./director-bonus.component.scss']
})
export class DirectorBonusComponent implements OnInit {
  submitting = false;
  directorBonus = [];
  total: any = 0;
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public directorBonusService: DirectorBonusService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'transaction_no': [''],
      'direct_downline_user_id': [''],
      'commission': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.directorBonus = [];
    this.directorBonusService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.directorBonus = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.total = data.total_commission;
        this.triggerScroll();
      } else {
        this.directorBonus = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'transaction_no': (this.searchForm && this.searchForm.value) ? this.searchForm.value.transaction_no : '',
      'direct_downline_user_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.direct_downline_user_id : '',
      'commission': (this.searchForm && this.searchForm.value) ? this.searchForm.value.commission : '',
    };
    this.get(params);
  }
}
